import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from '../app.models';
import { createIsEqualSelector } from '../shared/ngrx/selector.utils';
import { simCardFeatureKey, SimCardState } from './sim-cards.models';

const selectFeature = createFeatureSelector<SimCardState>(simCardFeatureKey);

export const selectLoading = createSelector(selectFeature, (state: SimCardState) => state.loading > 0);
export const selectSimCards = createIsEqualSelector(selectFeature, (state: SimCardState) => state.simCards);
export const selectSimCardCount = createSelector(selectFeature, (state: SimCardState) => state.totalCount);
